'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let AbstractUserProvider = exports.AbstractUserProvider = function () {
  function AbstractUserProvider() {
    _classCallCheck(this, AbstractUserProvider);
  }

  _createClass(AbstractUserProvider, [{
    key: 'loadUserByIdentityId',

    /**
     * @param {String} id
     * @param {Function} callback
     */
    value: function loadUserByIdentityId(id, callback) {
      throw new Error(`Abstract method not implemented.`);
    }
  }]);

  return AbstractUserProvider;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/AbstractUserProvider.js
// module id = 177
// module chunks = 0